import { biErrorMessage } from '@euler/app/flows/bi-dashboards/functions/biErrors';
import { useConfirm } from '@euler/functions/ux/useConfirm';
import { BiUploadView } from '@euler/model/bi/upload';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useState } from 'react';
import { biUploadDeleteText } from './biUploadPhase';

/** Deleting an upload by its uploader, after a confirmation. */
export function useBiUploadDelete(onDeleted: () => void) {
  const { biService } = useServiceFactory();
  const confirm = useConfirm();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const remove = useCallback(
    async (view: BiUploadView) => {
      const ok = await confirm({
        title: '删除上传',
        message: biUploadDeleteText(view),
        confirmButtonText: '删除',
        destructive: true,
      });
      if (!ok) return;
      setDeleting(true);
      setError(null);
      try {
        await biService.deleteUpload(view.id);
        onDeleted();
      } catch (failure) {
        console.error('BI upload delete failed', view.id, failure);
        setError(biErrorMessage(failure, '没有删除成功，请稍后重试。'));
      } finally {
        setDeleting(false);
      }
    },
    [biService, confirm, onDeleted],
  );
  return { deleting, error, remove };
}
